import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, Router } from "@angular/router";
import { NGXLogger } from "ngx-logger";
import { AUTH_SVC, AuthService } from "@company-box/services";

export function requireLogin(): CanActivateFn {
  return async (_route: ActivatedRouteSnapshot) => {
    const authService: AuthService = inject(AUTH_SVC);
    const logger = inject(NGXLogger);
    const router = inject(Router);
    logger.trace("checking access");

    return new Promise<boolean>((resolve, reject) => {
      const token = authService.getToken();
      if (token?.accessToken) {
        logger.trace("checking roles");

        if (token && authService.validate(token, ["CSR"], "")) {
          logger.trace("User has 'csr' role");
          resolve(true);
        } else {
          logger.trace("User does NOT have 'csr' role");
          // TODO: redirect to an access denied page
          // toastr.error("You don't have permission to access this page");
          return reject(false);
        }
      } else {
        logger.info("redirecting to /login");
        router.navigate(["/login"]);
        reject(false);
      }
    });
  };
}
